<template>
    <div class="jo-ocis" id="ocis">
      <h2 v-if="lang == 'zh'">OCIS码</h2>
      <h2 v-else>OCIS codes</h2>
      <p>
          <span class="a" v-for="(item,index) in ocis">
            {{item}}{{index!=(ocis.length-1)?';':''}}
          </span>
      </p>
    </div>
</template>

<script>
    export default {
      data() {
        return {
          lang: this.ARTICLE.defaultlang,
          ocis: []
        }
      },
      created() {
          this.ocis = this.ARTICLE.ocis;
      },
      activated() {
        this.$bus.on('currentLang', (lang) => {
          this.lang = lang;
        })
      }
    }
</script>
<style lang="scss" scoped>
    .jo-ocis {
      h2 {
        background: none;
        color: #333;
      }
      .a{
        color:#00a2af;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/ocis/ocis.vue